const isPresent = (value) => value !== null && value !== undefined && value !== '';

export const getStakeRowKey = (stake, index) => {
  const keyParts = [
    stake?.tx_hash,
    stake?.wallet,
    stake?.start_lock_time,
    stake?.udate,
    stake?.symbol,
    stake?.value,
  ]
    .filter(isPresent)
    .map((part) => String(part));

  if (!keyParts.length) {
    return `stake-row-${index}`;
  }

  return `${keyParts.join('__')}__${index}`;
};

export default getStakeRowKey;
